import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { base44 } from '@/api/base44Client';
import { Trophy, Users } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export default function ChallengeDrawStatus({ challenge, user }) {
  const { data: draw } = useQuery({
    queryKey: ['challengeDraw', challenge.id],
    queryFn: async () => {
      // Fetch draw by challenge_id only (not by raffle_month)
      // This is important for challenges that span multiple months
      const draws = await base44.entities.ChallengeDraw.filter({
        challenge_id: challenge.id
      });
      return draws?.[0] || null;
    }
  });

  if (!draw) {
    return (
      <div className="text-center py-2">
        <p className="text-xs text-[#B3B6C2] uppercase tracking-wider">Tirage en fin de mois</p>
      </div>
    );
  }

  const isWinner = user && draw.winner_user_id === user.id;
  const isFinalist = user && draw.finalists_user_ids?.includes(user.id);

  return (
    <div className="space-y-2 pt-3 border-t border-[#1B1E28]">
      {isWinner ? (
        <div className="bg-gradient-to-r from-amber-600 to-amber-700 p-3 rounded-lg text-center">
          <p className="text-white font-black text-lg">🎉 Respect. Tu gagnes ta place.</p>
          <p className="text-xs text-amber-100 mt-1">{new Date(draw.draw_date).toLocaleDateString('fr-FR')}</p>
        </div>
      ) : isFinalist ? (
        <div className="bg-[#1B1E28] border border-[#6E2BFF] p-3 rounded-lg text-center">
          <p className="text-white font-bold text-sm">Tu étais dans les 10. Bien joué.</p>
          <p className="text-xs text-[#B3B6C2] mt-1">{draw.finalists_count} finalistes</p>
        </div>
      ) : (
        <div className="bg-[#1B1E28] p-3 rounded-lg text-center">
          <p className="text-[#B3B6C2] text-sm">Le tirage est terminé.</p>
          <p className="text-xs text-[#B3B6C2] mt-1">Prochain Challenge bientôt.</p>
        </div>
      )}
    </div>
  );
}